import { PrintItemTBodyLayout, PrintItemTHeadLayout, PrintSectionLayout } from "../../layout";

import type { QueryData } from "../../../model";

type Props = {
	options: QueryData["aliveItemsPerReservation"]["options"];
};

export const NonDateOptionsOfPrintComposition = ({ options }: Props) => {
	return (
		<PrintSectionLayout titleChildren={<p className="text-sm font-bold">日ごとに紐づかないオプション</p>}>
			<div>
				<PrintItemTHeadLayout />

				{options.map((option, index) => {
					const { name, amount, hostInsertedPrice, discountedPrice, price } = option;
					const optionNameText = `${name} x ${amount}個`;
					const actualPrice = hostInsertedPrice ?? discountedPrice ?? price;

					return (
						<PrintItemTBodyLayout
							key={index}
							free="その他のオプション"
							name={optionNameText}
							price={price}
							actualPrice={actualPrice}
						/>
					);
				})}
			</div>
		</PrintSectionLayout>
	);
};
